import * as Checkbox from "@radix-ui/react-checkbox";
import { CheckIcon } from "@radix-ui/react-icons";
import { styled } from "../../../stitches.config";

interface CheckBoxProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  label?: string;
}

// Styled components using real colors (no tokens)
const StyledCheckbox = styled(Checkbox.Root, {
  all: "unset",
  width: 20,
  height: 20,
  backgroundColor: "#ffffff", // white
  borderRadius: "4px",
  border: "1px solid #9ca3af", // gray-400
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 150ms ease",

  "&:hover": {
    borderColor: "#4b5563", // gray-600
  },

  "&:focus": {
    boxShadow: "0 0 0 2px #166534", // primary focus ring
  },

  '&[data-state="checked"]': {
    backgroundColor: "#166534", // your primary color
    borderColor: "#166534",
  },
});

const StyledIndicator = styled(Checkbox.Indicator, {
  color: "#ffffff", // white icon when checked
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const CheckBox = ({
  checked,
  setChecked,
  label = "Checkbox",
}: CheckBoxProps) => {
  return (
    <StyledCheckbox
      checked={checked}
      onCheckedChange={(value) => setChecked(!!value)}
      aria-label={label}
    >
      <StyledIndicator>
        <CheckIcon width={16} height={16} />
      </StyledIndicator>
    </StyledCheckbox>
  );
};
